/**
 * Adaprox Theme — Cart Drawer
 * Slide-in cart panel with AJAX updates, shipping bar, and upsell carousel.
 */
(function () {
  'use strict';

  /* ─── DOM refs ─── */
  var overlay   = document.querySelector('[data-cart-overlay]');
  var drawer    = document.querySelector('[data-cart-drawer]');
  var body      = document.querySelector('[data-cart-body]');
  var itemsWrap = document.querySelector('[data-cart-items]');
  var emptyEl   = document.querySelector('[data-cart-empty]');
  var countEl   = document.querySelector('[data-cart-drawer-count]');
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  var checkoutBtn = document.querySelector('[data-checkout-btn]');
  var footerEl    = document.querySelector('[data-cart-footer]');
  var loadingEl   = document.querySelector('[data-cart-loading]');

  /* Shipping bar */
  var shippingBar      = document.querySelector('[data-shipping-bar]');
  var shippingMsg      = document.querySelector('[data-shipping-msg]');
  var shippingProgress = document.querySelector('[data-shipping-progress]');
  var shippingToggle   = document.querySelector('[data-shipping-toggle]');
  var shippingChevron  = document.querySelector('[data-shipping-chevron]');

  /* Upsell */
  var upsellSection  = document.querySelector('[data-upsell-section]');
  var upsellCarousel = document.querySelector('[data-upsell-carousel]');
  var upsellPrev     = document.querySelector('[data-upsell-prev]');
  var upsellNext     = document.querySelector('[data-upsell-next]');

  /* Config */
  var FREE_SHIPPING_THRESHOLD = 10000; // cents
  var upsellCollapsed = false;

  /* State */
  var isOpen = false;
  var isUpdating = false;
  var upsellProducts = [];
  var lastCart = null;

  /* ─── Helpers ─── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error(r.statusText);
      return r.json();
    });
  }

  /* ─── Open / Close ─── */
  function openDrawer() {
    if (lastCart) {
      // Have cached data — render immediately, no loading skeleton
      if (loadingEl) loadingEl.classList.add('hidden');
      if (itemsWrap) itemsWrap.classList.remove('hidden');
      renderCart(lastCart);
      show();
      // Silently refresh in background
      fetchJSON('/cart.js').then(function (cart) {
        lastCart = cart;
        renderCart(cart);
      }).catch(function () {});
    } else {
      // First open — show loading skeleton
      if (loadingEl) loadingEl.classList.remove('hidden');
      if (itemsWrap) itemsWrap.classList.add('hidden');
      if (emptyEl) emptyEl.classList.add('hidden');
      if (footerEl) footerEl.classList.add('hidden');
      if (shippingBar) shippingBar.classList.add('hidden');

      show();
      fetchJSON('/cart.js').then(function (cart) {
        if (loadingEl) loadingEl.classList.add('hidden');
        if (itemsWrap) itemsWrap.classList.remove('hidden');
        lastCart = cart;
        renderCart(cart);
      }).catch(function () {
        if (loadingEl) loadingEl.classList.add('hidden');
        if (itemsWrap) itemsWrap.classList.remove('hidden');
        if (emptyEl) emptyEl.classList.remove('hidden');
      });
    }
  }

  function show() {
    isOpen = true;
    overlay.classList.remove('opacity-0', 'invisible');
    overlay.classList.add('opacity-100', 'visible');
    drawer.classList.remove('translate-x-full');
    drawer.classList.add('translate-x-0');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    isOpen = false;
    overlay.classList.add('opacity-0', 'invisible');
    overlay.classList.remove('opacity-100', 'visible');
    drawer.classList.add('translate-x-full');
    drawer.classList.remove('translate-x-0');
    document.body.style.overflow = '';
  }

  /* Close triggers */
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeDrawer();
  });

  /* Cart trigger buttons */
  document.querySelectorAll('[data-cart-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });

  /* ─── Render Cart ─── */
  function renderCart(cart) {
    if (loadingEl) loadingEl.classList.add('hidden');
    if (itemsWrap) itemsWrap.classList.remove('hidden');
    lastCart = cart;

    var items = cart.items || [];
    var total = cart.total_price || 0;
    var count = cart.item_count || 0;

    /* Header count + badge */
    if (countEl) countEl.textContent = count;
    var headerBadge = document.getElementById('CartCount');
    if (headerBadge) headerBadge.textContent = count;

    /* Subtotal */
    if (subtotalEl) subtotalEl.textContent = formatMoney(total);

    /* Show/hide checkout + footer elements */
    if (checkoutBtn) checkoutBtn.style.display = count > 0 ? '' : 'none';

    /* Empty state vs items */
    if (items.length === 0) {
      if (itemsWrap) itemsWrap.innerHTML = '';
      if (emptyEl) emptyEl.classList.remove('hidden');
      if (shippingBar) shippingBar.classList.add('hidden');
      if (footerEl) footerEl.classList.add('hidden');
      return;
    }

    if (emptyEl) emptyEl.classList.add('hidden');
    if (shippingBar) shippingBar.classList.remove('hidden');
    if (footerEl) footerEl.classList.remove('hidden');

    /* Shipping bar */
    updateShippingBar(total);

    /* Build item HTML */
    var html = '';
    items.forEach(function (item, idx) {
      var line = idx + 1;
      var optionsHtml = '';
      if (item.variant_title) {
        optionsHtml = '<p class="text-xs text-gray-400 font-inter mt-0.5">' + escapeHtml(item.variant_title) + '</p>';
      }

      var priceHtml = '';
      if (item.original_line_price > item.final_line_price) {
        priceHtml =
          '<span class="text-sm font-semibold text-orange font-sora">' + formatMoney(item.final_line_price) + '</span>' +
          '<span class="text-xs text-gray-400 line-through ml-1 font-inter">' + formatMoney(item.original_line_price) + '</span>';
      } else {
        priceHtml = '<span class="text-sm font-semibold text-navy font-sora">' + formatMoney(item.final_line_price) + '</span>';
      }

      html +=
        '<div class="flex gap-4 p-3 bg-gray-50 rounded-xl">' +
          '<a href="' + item.url + '" class="w-20 h-20 rounded-lg overflow-hidden bg-gray-100 flex-shrink-0">' +
            '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" class="w-full h-full object-cover" loading="lazy">' +
          '</a>' +
          '<div class="flex-1 min-w-0">' +
            '<a href="' + item.url + '" class="text-sm font-semibold text-navy font-sora leading-tight hover:underline block truncate">' + escapeHtml(item.product_title) + '</a>' +
            optionsHtml +
            '<div class="mt-1">' + priceHtml + '</div>' +
            '<div class="flex items-center justify-between mt-2">' +
              '<div class="flex items-center border border-gray-200 rounded-full">' +
                '<button type="button" class="w-7 h-7 flex items-center justify-center text-gray-400 hover:text-navy transition-colors" data-line-minus="' + line + '" aria-label="Decrease quantity">' +
                  '<svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" d="M5 12h14"/></svg>' +
                '</button>' +
                '<span class="w-6 text-center text-sm font-semibold text-navy font-sora">' + item.quantity + '</span>' +
                '<button type="button" class="w-7 h-7 flex items-center justify-center text-gray-400 hover:text-navy transition-colors" data-line-plus="' + line + '" aria-label="Increase quantity">' +
                  '<svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" d="M12 5v14M5 12h14"/></svg>' +
                '</button>' +
              '</div>' +
              '<button type="button" class="p-1.5 text-gray-300 hover:text-red-500 transition-colors" data-line-remove="' + line + '" aria-label="Remove item">' +
                '<svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    });

    if (itemsWrap) itemsWrap.innerHTML = html;

    /* Bind quantity / remove buttons */
    bindItemButtons();

    /* Upsell: auto-collapse when >= threshold, auto-expand when below */
    if (upsellProducts.length > 0) {
      setUpsellCollapsed(total >= FREE_SHIPPING_THRESHOLD);
    }
  }

  /* ─── Item button handlers ─── */
  function bindItemButtons() {
    document.querySelectorAll('[data-line-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(this.getAttribute('data-line-minus'), 10);
        var qtyEl = this.nextElementSibling;
        var qty = parseInt(qtyEl.textContent, 10);
        changeLineQuantity(line, Math.max(0, qty - 1));
      });
    });

    document.querySelectorAll('[data-line-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(this.getAttribute('data-line-plus'), 10);
        var qtyEl = this.previousElementSibling;
        var qty = parseInt(qtyEl.textContent, 10);
        changeLineQuantity(line, qty + 1);
      });
    });

    document.querySelectorAll('[data-line-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(this.getAttribute('data-line-remove'), 10);
        changeLineQuantity(line, 0);
      });
    });
  }

  function changeLineQuantity(line, quantity) {
    if (isUpdating) return;
    isUpdating = true;

    fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (cart) {
      renderCart(cart);
    }).catch(function (err) {
      console.error('Cart update failed', err);
    }).finally(function () {
      isUpdating = false;
    });
  }

  /* ─── Shipping Bar ─── */
  function updateShippingBar(totalPrice) {
    if (!shippingProgress) return;

    var pct = Math.min(100, (totalPrice / FREE_SHIPPING_THRESHOLD) * 100);
    shippingProgress.style.width = pct + '%';

    if (totalPrice >= FREE_SHIPPING_THRESHOLD) {
      if (shippingMsg) shippingMsg.innerHTML = '<strong class="text-emerald-600">Free shipping is offered!</strong> \uD83C\uDF89';
    } else {
      var remaining = FREE_SHIPPING_THRESHOLD - totalPrice;
      if (shippingMsg) {
        shippingMsg.innerHTML =
          'Only <strong>' + formatMoney(remaining) + '</strong> away for free shipping!';
      }
    }
  }

  /* ─── Upsell Collapse / Expand ─── */
  function setUpsellCollapsed(collapsed) {
    upsellCollapsed = collapsed;
    if (!upsellSection) return;
    if (collapsed) {
      upsellSection.style.maxHeight = '0';
      upsellSection.style.opacity = '0';
    } else {
      upsellSection.style.maxHeight = '300px';
      upsellSection.style.opacity = '1';
    }
    /* Rotate chevron */
    if (shippingChevron) {
      shippingChevron.style.transform = collapsed ? 'rotate(0deg)' : 'rotate(180deg)';
    }
  }

  /* Toggle click */
  if (shippingToggle) {
    shippingToggle.addEventListener('click', function () {
      setUpsellCollapsed(!upsellCollapsed);
    });
  }

  /* ─── Upsell Carousel ─── */
  function initUpsell() {
    var jsonEl = document.querySelector('[data-upsell-products]');
    if (!jsonEl) return;
    try {
      upsellProducts = JSON.parse(jsonEl.textContent);
    } catch (e) {
      upsellProducts = [];
    }

    if (!upsellCarousel || upsellProducts.length === 0) {
      /* Hide upsell inner content when no products */
      var upsellInner = document.querySelector('[data-upsell-inner]');
      if (upsellInner) upsellInner.style.display = 'none';
      if (upsellSection) upsellSection.style.maxHeight = '0';
      return;
    }

    var html = '';
    upsellProducts.forEach(function (p) {
      var priceHtml = '';
      if (p.compare_at_price && p.compare_at_price > p.price) {
        priceHtml =
          '<span class="text-sm font-bold text-orange font-sora">' + formatMoney(p.price) + '</span>' +
          '<span class="text-xs text-gray-400 line-through ml-1 font-inter">' + formatMoney(p.compare_at_price) + '</span>';
      } else {
        priceHtml = '<span class="text-sm font-bold text-navy font-sora">' + formatMoney(p.price) + '</span>';
      }

      html +=
        '<div class="flex-shrink-0 w-72 border border-gray-100 rounded-xl overflow-hidden bg-gray-50">' +
          '<div class="flex gap-3 p-3">' +
            '<a href="' + escapeHtml(p.url) + '" class="w-20 h-20 rounded-lg overflow-hidden bg-white flex-shrink-0">' +
              '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" class="w-full h-full object-contain" loading="lazy">' +
            '</a>' +
            '<div class="flex-1 min-w-0">' +
              '<h4 class="text-sm font-semibold text-navy font-sora truncate">' + escapeHtml(p.title) + '</h4>' +
              '<p class="text-xs text-gray-400 font-inter mt-0.5 line-clamp-2">' + escapeHtml(p.description) + '</p>' +
              '<div class="mt-1">' + priceHtml + '</div>' +
            '</div>' +
          '</div>' +
          '<div class="px-3 pb-3">' +
            '<button type="button" class="w-full py-2 text-sm font-semibold text-white rounded-lg transition-opacity hover:opacity-90 font-sora bg-navy" data-upsell-add="' + p.id + '">Add to Cart</button>' +
          '</div>' +
        '</div>';
    });
    upsellCarousel.innerHTML = html;

    /* Bind add buttons */
    upsellCarousel.querySelectorAll('[data-upsell-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (isUpdating) return;
        isUpdating = true;
        var variantId = parseInt(this.getAttribute('data-upsell-add'), 10);
        this.innerHTML = '<svg class="animate-spin h-5 w-5 mx-auto" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>';
        this.disabled = true;
        var self = this;

        fetchJSON('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function () {
          return fetchJSON('/cart.js');
        }).then(function (cart) {
          renderCart(cart);
          self.textContent = 'Add to Cart';
          self.disabled = false;
        }).catch(function (err) {
          console.error('Upsell add failed', err);
          self.textContent = 'Add to Cart';
          self.disabled = false;
        }).finally(function () {
          isUpdating = false;
        });
      });
    });

    /* Arrows — always visible, scroll on click */
    if (upsellPrev) upsellPrev.addEventListener('click', function () {
      upsellCarousel.scrollBy({ left: -280, behavior: 'smooth' });
    });
    if (upsellNext) upsellNext.addEventListener('click', function () {
      upsellCarousel.scrollBy({ left: 280, behavior: 'smooth' });
    });
  }


  /* ─── Escape HTML ─── */
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ─── Public API ─── */
  window.openCartDrawer = openDrawer;
  window.refreshCartDrawer = function () {
    if (!isOpen) return;
    fetchJSON('/cart.js').then(renderCart).catch(function () {});
  };

  /* ─── Init ─── */
  initUpsell();

})();
